// extracted by mini-css-extract-plugin
export default {"modifyPassword":"modifyPassword-XtXEb","modifyPasswordBtns":"modifyPassword-btns-YpAvD"};